import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";

import { FullPageSpinner } from "@/components/full-page-spinner";
import { LoginPage } from "@/features/auth/login-page";
import { SignupPage } from "@/features/auth/signup-page";
import { TotpPage } from "@/features/auth/totp-page";
import { MailboxPage } from "@/features/messages/mailbox-page";
import { SearchPage } from "@/features/messages/search-page";
import { SettingsPage } from "@/features/settings/settings-page";

import { AppShell } from "./layout/app-shell";
import { MailboxIndexRedirect, MailboxRedirect } from "./layout/mailbox-redirect";
import { NotFoundPage } from "./layout/not-found-page";
import { RouteErrorPage } from "./layout/route-error-page";

// Route-level code splitting: the admin panel is only fetched when visited.
const AdminPage = lazy(() => import("@/features/admin/admin-page"));

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/login/totp", element: <TotpPage /> },
  { path: "/signup", element: <SignupPage /> },
  {
    path: "/",
    element: <AppShell />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <MailboxRedirect /> },
      { path: "mail/:mailboxId", element: <MailboxIndexRedirect /> },
      { path: "mail/:mailboxId/folder/:folder", element: <MailboxPage /> },
      { path: "mail/:mailboxId/starred", element: <MailboxPage /> },
      { path: "mail/:mailboxId/label/:labelId", element: <MailboxPage /> },
      { path: "mail/:mailboxId/search", element: <SearchPage /> },
      { path: "settings", element: <SettingsPage /> },
      {
        path: "admin",
        element: (
          <Suspense fallback={<FullPageSpinner label="Loading admin panel" />}>
            <AdminPage />
          </Suspense>
        ),
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
